var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1102.53,190h-285.07c-86.97,0-157.47,70.47-157.47,170.85l.03,158.83c.3,56.62,38.41,106.11,93.16,120.77l280.93,75.28,25.88-96.59-265.06-71.02c-20.61-5.52-34.94-24.2-34.94-45.54v-143.98c0-39.95,25.36-68.59,56.65-68.59h286.71c31.29,0,56.65,28.64,56.65,68.59v31.41h100v-29.15c0-100.38-70.5-170.85-157.47-170.85ZM1166.82,439.55l-280.93-75.28-25.88,96.59,265.06,71.02c20.61,5.52,34.94,24.2,34.94,45.54v143.98c0,39.95-25.36,68.59-56.65,68.59h-286.71c-31.29,0-56.65-28.64-56.65-68.59v-31.41h-100v29.15c0,100.38,70.5,170.85,157.47,170.85h285.07c86.97,0,157.47-70.47,157.47-170.85l-.03-158.83c-.3-56.62-38.41-106.11-93.16-120.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.868103266fc13b5e8d0b03d65504579b.svg";
export { ForwardRef as ReactComponent };